import { ATLAS } from '../data/atlasConfig.js';

// Wine-law terminology layer: the data model keeps German field names
// (anbaugebiet/bereich) in every atlas; only the DISPLAYED words differ.
export const regionTerm = () => ATLAS.terms.region;
export const subregionTerm = () => ATLAS.terms.subregion;
